import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Utility function to recursively remove database-managed fields with circular reference protection
export const removeDbFields = (obj: any, seen = new WeakSet()): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  // Handle primitive types
  if (typeof obj !== 'object') {
    return obj;
  }
  
  // Check for circular references
  if (seen.has(obj)) {
    console.warn('⚠️ Circular reference detected, skipping');
    return '[Circular Reference]';
  }
  seen.add(obj);
  
  if (Array.isArray(obj)) {
    const result = obj.map(item => removeDbFields(item, seen));
    seen.delete(obj);
    return result;
  }
  
  const filtered: any = {};
  for (const [key, value] of Object.entries(obj)) {
    // Skip database-managed fields but preserve id for frontend use
    if (key === '_id') {
      // Convert MongoDB _id to id for frontend consistency
      filtered['id'] = value;
    } else if (key === 'id') {
      // Preserve existing id field
      filtered['id'] = value;
    } else if (!['__v'].includes(key)) {
      // Keep createdAt and updatedAt for display purposes, only remove version key
      filtered[key] = removeDbFields(value, seen);
    }
  }
  
  seen.delete(obj);
  return filtered;
};
